export function NewIcon() {
  return (
    <span
      className="
    px-1 py-[1px] text-[9px] font-medium
    text-red-600 bg-red-50 border border-red-200 rounded-[3px]
  "
    >
      NEW
    </span>
  );
}
